module.exports = __webpack_public_path__ + "assets/img/news2.11c64b48.jpg";